import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';

import NavigationBarAdmin from './NavigationBarAdmin/NavigationBarAdmin';

import Page from '../Common/Page';

import UsersAdminPage from './UsersAdmin/UsersAdminPage';
import UserEditPage from './UsersAdmin/UserEditPage';

import NewsAdminPage from './NewsAdmin/NewsAdminPage';
import NewsCreatePage from './NewsAdmin/NewsCreatePage';
import NewsEditPage from './NewsAdmin/NewsEditPage';

import PagesAdminPage from './PagesAdmin/PagesAdminPage';
import PageCreatePage from './PagesAdmin/PageCreatePage';
import PageEditPage from './PagesAdmin/PageEditPage';

import EventsAdminPage from './EventsAdmin/EventsAdminPage';
import EventCreatePage from './EventsAdmin/EventCreatePage';
import EventEditPage from './EventsAdmin/EventEditPage';

import EventRegistrationsAdminPage from './EventRegistrationsAdmin/EventRegistrationsAdminPage';
import EventRegistrationCreatePage from './EventRegistrationsAdmin/EventRegistrationCreatePage';
import EventRegistrationEditPage from './EventRegistrationsAdmin/EventRegistrationEditPage';

import TasksAdminPage from './TasksAdmin/TasksAdminPage';
import TaskCreatePage from './TasksAdmin/TaskCreatePage';
import TaskEditPage from './TasksAdmin/TaskEditPage';

import TaskRegistrationCreatePage from './TaskRegistrationsAdmin/TaskRegistrationCreatePage';
import TaskRegistrationEditPage from './TaskRegistrationsAdmin/TaskRegistrationEditPage';

import './AdminApp.css';

function AdminApp(props) {
    return (
        <div>
            <NavigationBarAdmin />
            <Page fullWidth>
                <Routes>
                    <Route
                        path="events/:eventId/tasks/:taskId/registrations/create"
                        element={<TaskRegistrationCreatePage />}
                    />
                    <Route
                        path="events/:eventId/tasks/:taskId/registrations/:taskRegId"
                        element={<TaskRegistrationEditPage />}
                    />
                    <Route path="events/:eventId/tasks/create" element={<TaskCreatePage/>}/>
                    <Route path="events/:eventId/tasks/:taskId" element={<TaskEditPage/>}/>
                    <Route path="events/:eventId/tasks" element={<TasksAdminPage/>}/>
                    <Route path="events/:eventId/registrations/create" element={<EventRegistrationCreatePage/>}/>
                    <Route path="events/:eventId/registrations/:regId" element={<EventRegistrationEditPage/>}/>
                    <Route path="events/:id/registrations" element={<EventRegistrationsAdminPage/>}/>
                    <Route path="events/create" element={<EventCreatePage/>}/>
                    <Route path="events/:id" element={<EventEditPage/>}/>
                    <Route path="events" element={<EventsAdminPage/>}/>
                    <Route path="news/create" element={<NewsCreatePage/>}/>
                    <Route path="news/:id" element={<NewsEditPage/>}/>
                    <Route path="news" element={<NewsAdminPage/>}/>
                    <Route path="pages/create" element={<PageCreatePage/>}/>
                    <Route path="pages/:id" element={<PageEditPage/>}/>
                    <Route path="pages" element={<PagesAdminPage/>}/>
                    <Route path="users/:id" element={<UserEditPage/>}/>
                    <Route path="users" element={<UsersAdminPage />}/>
                    <Route render={() => <Navigate to="events" />} />
                </Routes>
            </Page>
        </div>
    );
}

export default AdminApp;